import React, { useState } from 'react';
import type { SearchInputBindings } from '../../hooks/useSearchInput';

interface Props {
  order: string | null;
  searchInputProps: SearchInputBindings;
  onClickOrder: (order: string | null) => void;
  onSubmitSearch: () => void;
}

export default function MobileSelector({
  order,
  searchInputProps,
  onClickOrder,
  onSubmitSearch,
}: Props) {
  const [checked, setChecked] = useState(false);

  const onClickSearchToggle = () => {
    setChecked(!checked);
  };

  // 並び順を選ぶと検索欄は閉じる。キーワードの消去は呼び出し元が行う
  const selectOrder = (orderValue: string | null) => {
    setChecked(false);
    onClickOrder(orderValue);
  };

  return (
    <React.Fragment>
      <div className="g-filter">
        <div className="list-group list-group-horizontal project-selector__navi">
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              selectOrder('in_progress');
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === 'in_progress' ? 'active' : ''
              }`}
            >
              新着順
            </div>
          </a>
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              selectOrder('amount');
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === 'amount' ? 'active' : ''
              }`}
            >
              人気順
            </div>
          </a>
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              selectOrder(null);
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === null || order === undefined ? 'active' : ''
              }`}
            >
              全て
            </div>
          </a>
        </div>
        <div className="search-icon__wrapper" onClick={onClickSearchToggle}>
          <span className={`search-icon ${checked ? 'is-checked' : ''}`} />
        </div>
      </div>
      <div className={`search-container ${checked ? 'is-checked' : ''}`}>
        <input
          {...searchInputProps}
          type="text"
          maxLength={50}
          placeholder="キーワードで検索"
        />
        <button onClick={onSubmitSearch}>検索</button>
      </div>
    </React.Fragment>
  );
}
